import { api } from '../../../plugins/axios';
export default class OrderReturn {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static async getOrdersReturns(params) {
		const res = await api.get('shipping/returns', {
			params,
		});
		return {
			data: res.data.result.orderReturns.data,
			totalRecords: res.data.result.orderReturns.total,
		};
	}

	static async getOrderReturnById(id) {
		const res = await api.get(`shipping/returns/${id}`);
		return new OrderReturn(res.data.result);
	}

	static createReturn(orderId, data) {
		return api.post(`shipping/returns/order/${orderId}`, data);
	}

	static async getAvailableProducts(params = {}) {
		const res = await api.get('main-order/orders/available-items-for-return', {
			params,
		});
		return {
			data: res.data.result.orders?.data || [],
			totalRecords: res.data.result.meta?.total || 0,
		};
	}

	async refundOrder(amount) {
		return api
			.post(`shipping/refund-order`, {
				main_order_return_id: this.id,
				amount,
			})
			.then((res) => res.data);
	}

	static acceptRejectReturnItems(data) {
		return api.post('/shipping/returns/items/accept-or-reject', data);
	}

	static itemRestock({ returnItemId, restock }) {
		return api.post('/shipping/returns/items/item-restock-status', {
			main_order_return_item_id: returnItemId,
			restock,
		});
	}

	async shipBySeller(data) {
		return api.post(`shipping/returns/ship-by-seller/${this.id}`, data);
	}

	async shipBySalesChannel(data) {
		return api.post(`shipping/returns/ship-by-sales-channel/${this.id}`, data);
	}

	async shipByLinker(data) {
		try {
			return await api.post(`shipping/returns/ship-by-linker/${this.id}`, data);
		} catch (err) {
			const msg = err?.response?.data?.message;
			Alert.error(msg || t('Error Msg'));
			console.error(err);
			throw err;
		}
	}

	async printLabel() {
		const { data } = await api.get(`shipping/returns/print-label/${this.id}`, {
			responseType: 'arraybuffer',
			headers: {
				'Content-Type': 'application/pdf',
				Accept: 'application/pdf',
			},
		});
		const blob = new Blob([data], { type: 'application/pdf' });
		return blob;
	}

	async updateStatus(status) {
		await api.post(`shipping/returns/update-status/${this.id}`, { status });
		this.shipment_status = status;
	}
}

export const shipmentStatusColor = {
	'in progress return': 'warning',
	Returned: 'success',
	'Return Failed': 'error',
	New: 'brand',
};

export const refundStatusColor = {
	pending: 'warning',
	refunded: 'success',
	canceled: 'error',
};

export const itemsAcceptStatusColor = {
	0: 'error',
	1: 'success',
	2: 'warning',
};
